import React from 'react';
import styled from 'styled-components';

const Styled = styled.div`
  position: relative;
  min-width: 50px;
  text-align: center;
  
  img {
    width: 100%;
    max-width: 50px;
    height: 50px;
    max-height: 50px;
    border: 1px solid #BEBEBE50;
    object-fit: contain;
  }
`;

// "1px solid #00a2ae50"

export function ImageThumbnail(props) {
    const { src, style, extra } = props;

    return (
        <Styled>
            <img src={src} alt="" style={style} />
            { extra }
        </Styled>
    );
}
